import axios from "axios";
import API from "../api";

export const TerminalModule = {
  state: {
    availableReaders: [],
    currentReader: null,
    terminal: null,
    terminalRequesting: false,
    terminalMessage: '',
    terminalExists: false,
    isRequesting: false,
    cancelled: false
  },
  actions: {
    connectToStripeTerminal({ commit, rootState }) {
      const { stripe_location_id, stripe_id } = rootState.vendor.vendor

      if (!stripe_location_id || !stripe_id) {
        return Promise.reject('Nothing to see here.')
      }
      commit("verifyTerminalConnection");

      return StripeTerminal.create({
        onFetchConnectionToken: () => {
          const request_uri = `${API.BASE_URL}${API.VENDOR}${API.STRIPE_TERMINAL}${API.CONNECT}`;

          return axios
            .post(request_uri, { stripe_id: stripe_id }, API.RequestHeaders())
            .then(response => {
              if (response.status == 200) {
                commit("verifyTerminalConnectionSuccess");
                return response.data.secret;
              } else {
                commit("verifyTerminalConnectionError", response);
                return response;
              }
            })
            .catch(error => {
              commit("verifyTerminalConnectionError", error.message);
              reject(error.message);
            })
        },

        onUnexpectedReaderDisconnect: () => {
          console.error('stripe reader disconnected')
        }
      });
    },
    discoverReaders({ commit, state, rootState}) {
      const configuration = {
        location: rootState.vendor.vendor.stripe_location_id,
        simulated: false
      }

      if (process.env.NODE_ENV !== 'production') {
        configuration.simulated = true
      }

      return new Promise((resolve, reject) => {
        state.terminal.discoverReaders(configuration)
          .then(res => {
            if (state.currentReader) {
              const readerStillExists = res.discoveredReaders.find(
                reader => reader.id === state.currentReader.id
              )
              if (!readerStillExists) {
                commit('setCurrentReader', null)
              }
            }

            if (res.error) {
              reject(`Failed to discover: ${res.error}`)
              // this.errorNotification(`Failed to discover: ${res.error}`);
            } else if (res.discoveredReaders.length === 0) {
              reject(`No available readers.`)
            } else {
              commit('setAvailableReaders', res.discoveredReaders)

              if (!state.currentReader) {
                commit('setCurrentReader', state.availableReaders[0])
              }

              state.terminal.connectReader(state.currentReader)
                .then(res => {
                  if (res.error) {
                    reject(`Failed to connect: ${ connectResult.error }`)
                  }
                  resolve(res.reader)
                })
                .catch(err => {
                  reject(err)
                })
            }
          })
          .catch(err => {
            reject(err)
          })
      })
    },
    initializeStripeTerminal({ commit }, terminal) {
      commit('setTerminal', terminal)
    },
    initializeTerminalIntegration({ commit, rootState}) {
      const vendor_id = rootState.vendor.vendor.id

      return new Promise((resolve, reject) => {
        commit("initializingTerminalIntegration");

        return axios.post(`${API.BASE_URL}${API.VENDOR}${API.STRIPE_TERMINAL}${API.LOCATION}`, {vendor_id}, API.RequestHeaders())
          .then(response => {
            if (response.status === 200) {
              commit("VENDOR_LOCATION_SUCCESS", { stripe_location_id: response.data.id }, { root: true });
              commit("terminalLocationSuccess");
              resolve(response.id);
            } else {
              commit("terminalLocationFailure", response);
              reject(response);
            }
          })
          .catch(error => {
            commit("terminalLocationFailure", error);
            reject(error);
          });
      });
    },
    registerStripeTerminal({ commit, rootState }, registrationInfo) {
      return new Promise((resolve, reject) => {
        commit("verifyTerminalConnection");
        let { stripe_id } = rootState.vendor.vendor;

        return axios
          .post(`${API.BASE_URL}${API.VENDOR}${API.STRIPE_TERMINAL}${API.REGISTER}`, {
            ...registrationInfo,
            stripe_id: stripe_id
          }, API.RequestHeaders())
          .then(response => {
            if (response.status == 200) {
              commit("verifyTerminalConnectionSuccess");
              resolve(response.data);
            } else {
              commit("verifyTerminalConnectionError", response);
              reject(response);
            }
          })
          .catch(error => {
            commit("verifyTerminalConnectionError", error.message);
            reject(error.message);
          });
      });
    },
    initiateTerminalCharge({ commit, rootState, dispatch }, chargeData) {
      const stripe_id = rootState.vendor.vendor.stripe_id

      return new Promise((resolve, reject) => {
        commit("initiatingChage");

        // const stripeFee = Math.round((chargeData.amount * .027 * 100) + 5);
        const totalCharge = chargeData.amount * 100;

        const paymentIntent = {
          "payment_method_types[]": "card_present",
          capture_method: 'manual',
          // on_behalf_of: stripe_id,
          stripe_id: stripe_id,
          // application_fee_amount: stripeFee,
          currency: 'usd', //TODO - This won't fly forever
          amount: totalCharge
        }

        return axios.post(`${API.BASE_URL}${API.VENDOR}${API.STRIPE_TERMINAL}${API.INTENT}`, paymentIntent, API.RequestHeaders())
          .then(response => {
            if (response.status === 200) {
              dispatch("capturePayment", response.data)
                .then(capturedPayment => {
                  resolve(capturedPayment)
                })
                .catch(error => {
                  commit("terminalChargeInitiateError", error.message);
                  reject(error.message);
                })
            } else {
              commit("terminalChargeInitiateError", response);
              reject(response);
            }
          })
          .catch(error => {
            commit("terminalChargeInitiateError", error.message);
            reject(error.message);
          });
      });
    },
    cancelledPayment({commit, state, rootState}, paymentIntent){
      commit("cancelPaymentCharge")

      const request_uri = `${API.BASE_URL}${API.VENDOR}${API.STRIPE_TERMINAL}${API.CANCEL}`;
      const params = {
        ...paymentIntent,
        stripe_id: rootState.vendor.vendor.stripe_id
      }

      return new Promise((resolve, reject) => {
        axios.post(request_uri, params, API.RequestHeaders())
          .then( response => {
            state.terminalMessage = "Payment Cancelled"
            resolve({ abandoned: true })
          })
          .catch(err => {
            reject(err)
          })
      })
    },
    capturePayment({ dispatch, state, commit }, paymentIntent) {
      commit("capturePaymentCharge")

      if (state.cancelled) {
        return dispatch('cancelledPayment', paymentIntent);
      }

      const { client_secret } = paymentIntent

      return new Promise((resolve, reject) => {
        state.terminal.collectPaymentMethod(client_secret)
          .then(result => {
            if (result.error) {
              commit("failedTerminalCharge", result.error.message)
              reject(`Collect payment method failed: ${result.error.message}`);
            } else {
              dispatch("confirmPaymentIntent", {...result.paymentIntent, client_secret})
                .then(confirmation => {
                  commit("paymentMethodCaptured")
                  resolve(confirmation)
                })
                .catch(err => {
                  reject(err)
                })
            }
          })
          .catch(err => {
            reject(err);
          });
      })
    },
    confirmPaymentIntent({ dispatch, state, rootState }, paymentIntent) {
      if (state.cancelled) {
        return dispatch('cancelledPayment', paymentIntent);
      }

      state.terminalMessage = "Confirming Payment Method"

      return new Promise((resolve, reject) => {
        return state.terminal.processPayment(paymentIntent)
          .then(confirmResult => {
            if (confirmResult.error) {
              reject("Confirm failed: " + confirmResult.error.message);
            } else if (confirmResult.paymentIntent) {
              if (state.cancelled) {
                dispatch('cancelledPayment', paymentIntent)
                  .then(res => {
                    resolve(res)
                  })
                  .catch(err => {
                    reject(err)
                  })
              }

              const { stripe_id } = rootState.vendor.vendor

              return axios.post(`${API.BASE_URL}${API.VENDOR}${API.STRIPE_TERMINAL}${API.CAPTURE}`, {
                ...paymentIntent,
                stripe_id: stripe_id
              }, API.RequestHeaders())
                .then( response => {
                  state.terminalMessage = "Payment Method Confirmed"
                  resolve(paymentIntent)
                })
                .catch(error => {
                  reject(error)
                })
            }
          })
          .catch(err => {
            reject(err)
          })
      });
    },
    connectReader({ state }, reader) {
      return state.terminal.connectReader(reader)
    },
    disconnectReader({ state }, reader) {
      return state.terminal.disconnectReader(reader)
    },
    readerConnected({ commit }, reader) {
      commit("readerConnectedUpdate", reader)
    },
    readerDisconnected({ commit }, reader) {
      commit("readerDisconnectedUpdate", reader)
    }
  },
  mutations: {
    initializingTerminalIntegration(state){
      state.isRequesting = true;
    },
    terminalLocationSuccess(state){
      state.isRequesting = false;
    },
    terminalLocationFailure(state, error){
      state.isRequesting = false;
      state.errored = true;
      state.error = error.message;
    },
    setToCancelled(state) {
      state.cancelled = true;
    },
    paymentMethodCaptured(state) {
      state.terminalRequesting = false;
      state.terminalMessage = ""
    },
    failedTerminalCharge(state, message) {
      state.terminalRequesting = false;
      state.terminalMessage = `Failed: ${message}`
    },
    initiatingChage(state) {
      state.terminalRequesting = true
      state.cancelled = false
      state.terminalMessage = "Initiating Charge"
    },
    capturePaymentCharge(state) {
      state.terminalMessage = "Ready to accept credit card."
    },
    cancelPaymentCharge(state) {
      state.terminalMessage = "Cancelling."
      state.cancelled = false;
      state.terminalRequesting = false
    },
    setCurrentReader(state, payload) {
      state.currentReader = payload;
    },
    setAvailableReaders(state, payload) {
      state.availableReaders = payload;
    },
    setTerminal(state, terminal) {
      state.terminal = terminal;
      terminal.clearCachedCredentials();
    },
    readerConnectedUpdate(state, reader) {
      state.currentReader = reader;
    },
    readerDisconnectedUpdate(state) {
      state.currentReader = null;
    },
    terminalChargeInitiateRequest(state) {
      state.isRequesting = true;
    },
    terminalChargeInitiateError(state, error) {
      state.isRequesting = false;
      state.errored = true;
      state.error = error.message;
    },
    verifyTerminalConnection(state) {
      state.isRequesting = true;
    },
    verifyTerminalConnectionSuccess(state) {
      state.terminalExists = true;
      state.isRequesting = false;
    },
    verifyTerminalConnectionError(state, error) {
      state.isRequesting = false;
      state.errored = true;
      state.error = error.message;
    }
  },
  getters: {
    getAvailableReaders(state) {
      return state.availableReaders
    },
    getCurrentReader(state) {
      return state.currentReader
    },
    getTerminal(state) {
      return state.terminal
    },
    getReaderConnectionStatus(state) {
      return state.terminal ? state.terminal.getConnectionStatus() : 'disconnected'
    }
  }
}